// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"a5e92cf1","453":"a09ec279","732":"e99e39f7","977":"769c9640"}[chunkId] + ".chunk.js";
};